import useUserPermissions from "@/common/hooks/useUserPermissions";
import { useNavigate } from "react-router-dom";
import { ROUTE_MAP } from "../constants/routeMap.constant";
import { ChartData } from "@/common/types/chart.type";
import { useMemo } from "react";

interface CustomXAxisTickProps {
  x?: number,
  y?: number,
  payload?: { value: string },
  chartFullData: ChartData['data'],
  dataKey: string
}

export const CustomXAxisTick = ({ x, y, payload, chartFullData, dataKey }: CustomXAxisTickProps) => {
  const navigate = useNavigate()

  const labelValue = payload?.value || ''

  const dataRow = useMemo(() => {
    return chartFullData.find((item: any) => item[dataKey] === labelValue);
  }, [dataKey])

  const entityId = dataRow?.object_id
  const objectType = dataRow?.object_type || ''

  const displayValue = labelValue.length > 25 ? `${labelValue.slice(0, 25)}...` : labelValue

  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions()
  const userHasPermissionToSeeEntity = isUserPermissionsPending || hasUserPermission(ROUTE_MAP[objectType]?.operationKlass)

  const handleClick = () => {
    if (!entityId || !objectType || !userHasPermissionToSeeEntity) return

    const basePath = ROUTE_MAP[objectType]?.url

    if (basePath) {
      navigate(`${basePath}/${entityId}`)
    }
  }

  const isClickable = !!objectType && !!ROUTE_MAP[objectType] && !!entityId && !!userHasPermissionToSeeEntity

  return (
    <g
      transform={`translate(${x},${y}) rotate(-25)`}
      className={isClickable ? "cursor-pointer group" : ""}
      onClick={isClickable ? handleClick : undefined}
    >
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        className={`text-[10px] font-bold ${isClickable ? 'group-hover:fill-[#fff] transition-colors' : ''}`}
      >
        {displayValue}
      </text>
    </g>
  )
}
